module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNS43NSAyNC45OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuMTYsMCwwLDEyLjI2SDMuNjFWMjVIMjIuMDZWMTIuMmgzLjY5Wm0tMiwyMy40OCwwLTguMzFoMy40OHY4LjMxWk0yMC41NiwxMC43VjIzLjQ4SDE2LjEyVjEzLjY3SDkuNjVsMCw5LjgxSDUuMTFWMTAuNzZIMy44MWw5LjMzLTguNjlMMjIsMTAuN1oiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/qcasino/home-white.svg
// module id = eoh4
// module chunks = 10